import { render, staticRenderFns } from "./ApprovalLink.vue?vue&type=template&id=31b296a2&"
import script from "./ApprovalLink.vue?vue&type=script&lang=js&"
export * from "./ApprovalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports